import comp from "./DynamicChildren";
export default comp;
